import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "account-box"
};
import { ref } from 'vue';
import { ElMessage, ElRow, ElButton, ElForm, ElOption, ElInput, ElSelect, ElImage } from 'element-plus';
import { request } from '@/manager/net_manager';
import { getPosition } from '@/tools/utils';
import store from '@/store'; // --- Props & Reactive Data ---

export default {
  __name: 'LoginRegisterBox',
  emits: ['getUser'],

  setup(__props, {
    emit: __emit
  }) {
    const loginForm = ref({
      account: '',
      password: ''
    });
    const registerForm = ref({
      account: '',
      password: '',
      nickname: '',
      verify_code: '',
      invite_code: ''
    });
    const resetForm = ref({
      account: '',
      password: '',
      verify_code: ''
    });
    const userType = ref('3');
    const registerMode = ref(false);
    const resetMode = ref(false);
    const countdown = ref(0);
    const timer = ref(null);
    const emits = __emit;

    const sendCode = account => {
      const regex = /^1[3-9]\d{9}$/;

      if (!regex.test(account) || account.length !== 11) {
        ElMessage.error('请输入正确的11位手机号');
        return;
      }

      request('user/sms_send/', {
        phone: account
      }, 'POST').then(response => {
        if (response.code === 0) {
          ElMessage.success('验证码已发送');
          countdown.value = 60;
          timer.value = setInterval(() => {
            countdown.value--;

            if (countdown.value <= 0) {
              clearInterval(timer.value);
            }
          }, 1000);
        } else {
          ElMessage.error({
            message: response.msg
          });
        }
      });
    };

    const getUserData = response => {
      store.commit('update_headers', response.data);
      localStorage.setItem('headers', JSON.stringify(response.data));
      emits('getUser');
    };

    const register = () => {
      const regex = /^[0-9a-zA-Z!@#$%^&*]{6,18}$/;

      if (!regex.test(registerForm.value.password)) {
        ElMessage.error('密码格式不对');
        return;
      }

      request('user/register/', registerForm.value, 'POST').then(response => {
        if (response.code === 0) {
          quitRegisterMode();
          getUserData(response);
        } else {
          ElMessage.error({
            message: response.msg
          });
        }
      });
    };

    const login = () => {
      if (!loginForm.value.account || loginForm.value.account.length < 2) {
        ElMessage.error('登入名至少2个字符');
        return;
      }

      if (!loginForm.value.password || loginForm.value.password.length < 6) {
        ElMessage.error('密码至少6个字符');
        return;
      }

      request('user/login/', { ...loginForm.value,
        user_type: userType.value
      }, 'POST').then(response => {
        if (response.code === 0) {
          loginForm.value.password = '';
          getUserData(response);
        } else {
          ElMessage.error({
            message: response.msg
          });
        }
      });
    };

    const resetPassword = () => {
      const regex = /^[0-9a-zA-Z!@#$%^&*]{6,18}$/;

      if (!regex.test(resetForm.value.password)) {
        ElMessage.error('密码格式不对');
        return;
      }

      request('user/password_reset/', resetForm.value, 'POST').then(response => {
        if (response.code === 0) {
          quitResetMode();
          ElMessage.success('密码重置成功');
        } else {
          ElMessage.error({
            message: response.msg
          });
        }
      });
    };

    const quitResetMode = () => {
      resetMode.value = false;
      countdown.value = 0;
      if (timer.value) clearInterval(timer.value);
      resetForms();
    };

    const quitRegisterMode = () => {
      registerMode.value = false;
      countdown.value = 0;
      if (timer.value) clearInterval(timer.value);
      resetForms();
    };

    const resetForms = () => {
      loginForm.value = {
        account: '',
        password: ''
      };
      registerForm.value = {
        account: '',
        password: '',
        nickname: '',
        verify_code: '',
        invite_code: ''
      };
      resetForm.value = {
        account: '',
        password: '',
        verify_code: ''
      };
    };

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "back-image-container"
      }, null, -1)), _createVNode(_unref(ElImage), {
        src: require('@/assets/image/logo256.png'),
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), registerMode.value ? (_openBlock(), _createBlock(_unref(ElForm), {
        key: 0,
        model: registerForm.value
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: registerForm.value.account,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => registerForm.value.account = $event),
          maxlength: "16",
          placeholder: "手机号",
          round: "",
          "show-word-limit": "",
          type: "text"
        }, {
          append: _withCtx(() => [_createVNode(_unref(ElButton), {
            class: _normalizeClass(["send-code", countdown.value > 0 ? 'disabled-send-code' : '']),
            onClick: _cache[0] || (_cache[0] = $event => sendCode(registerForm.value.account))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(countdown.value <= 0 ? '获取验证码' : `(${countdown.value}s)`), 1)]),
            _: 1
          }, 8, ["class"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: registerForm.value.verify_code,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => registerForm.value.verify_code = $event),
            placeholder: "验证码",
            type: "text"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: registerForm.value.nickname,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => registerForm.value.nickname = $event),
            placeholder: "如何称呼"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: registerForm.value.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => registerForm.value.password = $event),
            placeholder: "密码口令",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: registerForm.value.invite_code,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => registerForm.value.invite_code = $event),
            placeholder: "邀请码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            class: "main-button",
            onClick: register
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("获取身份", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("div", {
            style: {
              "flex": "1"
            }
          }, null, -1)), _createVNode(_unref(ElButton), {
            onClick: quitRegisterMode
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" 前往登录 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])) : resetMode.value ? (_openBlock(), _createBlock(_unref(ElForm), {
        key: 1,
        model: resetForm.value
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: resetForm.value.account,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => resetForm.value.account = $event),
          maxlength: "16",
          placeholder: "手机号",
          round: "",
          "show-word-limit": "",
          type: "text"
        }, {
          append: _withCtx(() => [_createVNode(_unref(ElButton), {
            class: _normalizeClass(["send-code", countdown.value > 0 ? 'disabled-send-code' : '']),
            onClick: _cache[6] || (_cache[6] = $event => sendCode(resetForm.value.account))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(countdown.value <= 0 ? '获取验证码' : `(${countdown.value}s)`), 1)]),
            _: 1
          }, 8, ["class"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: resetForm.value.verify_code,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => resetForm.value.verify_code = $event),
            placeholder: "验证码",
            type: "text"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: resetForm.value.password,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => resetForm.value.password = $event),
            placeholder: "设置新的密码口令",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            class: "main-button",
            onClick: resetPassword
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("重置密码口令", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: _cache[10] || (_cache[10] = $event => {
              quitResetMode();
              registerMode.value = true;
            })
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" 前往注册 ", -1)]))]),
            _: 1
          }), _cache[22] || (_cache[22] = _createElementVNode("div", {
            style: {
              "flex": "1"
            }
          }, null, -1)), _createVNode(_unref(ElButton), {
            onClick: quitResetMode
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" 前往登录 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])) : (_openBlock(), _createBlock(_unref(ElForm), {
        key: 2,
        model: loginForm.value
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: loginForm.value.account,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => loginForm.value.account = $event),
          maxlength: "16",
          placeholder: "登入名",
          "show-word-limit": "",
          type: "text"
        }, {
          append: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: userType.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => userType.value = $event),
            placeholder: "请选择",
            style: {
              "width": "96px"
            },
            "popper-class": "commonPopper"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({
              length: 4
            }), (value, index) => {
              return _openBlock(), _createBlock(_unref(ElOption), {
                key: index,
                label: _unref(getPosition)(index.toString()),
                value: index.toString()
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: loginForm.value.password,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => loginForm.value.password = $event),
            placeholder: "密码口令",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            class: "main-button",
            onClick: login
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("链接雾海", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "login-operation-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: _cache[14] || (_cache[14] = $event => resetMode.value = true)
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" 忘记密码? ", -1)]))]),
            _: 1
          }), _cache[26] || (_cache[26] = _createElementVNode("div", {
            style: {
              "flex": "1"
            }
          }, null, -1)), _createVNode(_unref(ElButton), {
            onClick: _cache[15] || (_cache[15] = $event => registerMode.value = true)
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" 前往注册 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]))]);
    };
  }

};